
import "../CreateClient/CreateClient.css";
import React, { useEffect, useState } from "react";
import { useGlobalContext } from "../../context";
import { radioType, selectType } from "../../interfaces";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

function SocialMedia({ client }: any) {

    const { socialMediaData, setSocialMediaData } = useGlobalContext();
    const [activeSocialMedia, setActiveSocialMedia] = useState<radioType | undefined>();

    const getClientSocialMediaData = (socialData:selectType[]): void => {
        if (socialData.length > 0) {
            const mediaCategorys: string[] = ["Facebook", "Linkedin", "Instagram", "TikTok", "YouTube", "Messenger", "X", "Pinterest", "Other"];
            let mediasUpdate: selectType[] = new Array();
            socialData.forEach((social: any, index: number) => {
                const activeCtg: string | undefined = mediaCategorys.find(category => category === social.key);
                let obj = {
                    id: index + 1,
                    text: social.value,
                    isOpen: false,
                    category: activeCtg ? mediaCategorys.map((category: string, number: number) => {
                            if (category === social.key) {
                                return {
                                    id: parseInt(`${index + 1}` + `${number + 1}`),
                                    title: category,
                                    active: true
                                }
                            }
                            else {
                                return {
                                    id: parseInt(`${index + 1}` + `${number + 1}`),
                                    title: category,
                                    active: false
                                }
                            }
                        })
                        :
                        mediaCategorys.map((category: string, number: number) => {
                            if (category === "Other") {
                                return {
                                    id: parseInt(`${index + 1}` + `${number + 1}`),
                                    title: social.key,
                                    active: true
                                }
                            }
                            else {
                                return {
                                    id: parseInt(`${index + 1}` + `${number + 1}`),
                                    title: category,
                                    active: false
                                }
                            }
                        })
                }
                mediasUpdate.push(obj);
            })
            setSocialMediaData(mediasUpdate);
        }
        else {
            setSocialMediaData([
                {
                    id:1,
                    text: "",
                    isOpen:false,
                    category: [
                        {
                            id: 11,
                            title: "Facebook",
                            active: true
                        },
                        {
                            id: 12,
                            title: "Instagram",
                            active: false
                        },
                        {
                            id: 13,
                            title: "LinkedIn",
                            active: false
                        },
                        {
                            id: 14,
                            title: "X",
                            active: false
                        },
                        {
                            id: 15,
                            title: "YouTube",
                            active: false
                        },
                        {
                            id: 16,
                            title: "TikTok",
                            active: false
                        },
                        {
                            id: 17,
                            title: "Pinterest",
                            active: false
                        },
                        {
                            id: 18,
                            title: "Other",
                            active: false
                        },
                    ]
                }]
            )
        }
    }

    useEffect(() => {
        if (client) {
            getClientSocialMediaData(client.additionalData.socialMediaList);
        }
    }, [client])

    const findActiveMedia = (mediaData: selectType): string | undefined => {
        const activeMedia = mediaData.category.find(item=> item.active);
        if (activeMedia) {
            return activeMedia.title;
        }
    }

    const openSelectWindow = (mediaData: selectType): void => {
        setSocialMediaData((socialMediaData: selectType[]) =>  socialMediaData.map((item: selectType) => item.id === mediaData.id ? { ...item, isOpen: !item.isOpen } : { ...item, isOpen: false }));
    }

    const onOptionClicked = (mediaData: selectType, categoryData: radioType) : void => {
        setSocialMediaData((socialMediaData: selectType[]) => socialMediaData.map((item: selectType) => {
            setActiveSocialMedia(item.category.find((ctg: radioType) => ctg.id === categoryData.id ));
            if (item.id === mediaData.id) {
                return {
                    ...item,
                    category: item.category.map((ctg: radioType) => ctg.id === categoryData.id ? {...ctg, active: true} : {
                        ...ctg,
                        active: false
                    }),
                    isOpen: false
                };
            }
            else {
                return { ...item }
            }
        }))
    }

    const changeMediaData = (value: string, mediaData: selectType): void => {
        setSocialMediaData((socialMediaData: selectType[]) =>  socialMediaData.map((item: selectType) => item.id === mediaData.id ? { ...item, text: value } : { ...item }));
    }

    const addSocialMedia = (): void => {
        if (socialMediaData.length < 5) {
            const lastId: number = socialMediaData[socialMediaData.length - 1].id + 1;
            setSocialMediaData((socialMediaData: selectType[]) => {
                return [
                    ...socialMediaData,
                    {
                        id: lastId,
                        text: "",
                        isOpen: false,
                        category: [
                            {
                                id: parseInt(lastId + "1"),
                                title: "Facebook",
                                active: true
                            },
                            {
                                id: parseInt(lastId + "2"),
                                title: "Instagram",
                                active: false
                            },
                            {
                                id: parseInt(lastId + "3"),
                                title: "LinkedIn",
                                active: false
                            },
                            {
                                id: parseInt(lastId + "4"),
                                title: "X",
                                active: false
                            },
                            {
                                id: parseInt(lastId + "5"),
                                title: "YouTube",
                                active: false
                            },
                            {
                                id: parseInt(lastId + "6"),
                                title: "TikTok",
                                active: false
                            },
                            {
                                id: parseInt(lastId + "9"),
                                title: "Messenger",
                                active: false
                            },
                            {
                                id: parseInt(lastId + "7"),
                                title: "Pinterest",
                                active: false
                            },
                            {
                                id: parseInt(lastId + "8"),
                                title: "Other",
                                active: false
                            },
                        ]
                    }
                ]
            });
        }
    }

    const deleteSocialMedia = (id: number) => {
        setSocialMediaData((socialMediaData: selectType[]) => socialMediaData.filter((item: selectType) => item.id !== id));
    }

    const changeOtherMedia = (value: string, media: selectType) => {
        setSocialMediaData((socialMediaData: selectType[]) => socialMediaData.map((item: selectType) => {
            if ( item.id === media.id ) {
                return { ...item,
                    category: item.category.map(ctg => ctg.active ? { ...ctg, title: value } : { ...ctg }),
                }
            }
            else {
                return { ...item }
            }
        }));
    }

    return(
        <div className="SocialMedia">
            <div className="form-phoneNumber-box">
                <label className="required" htmlFor="">Social Media <span>Max 10</span></label>
                <label htmlFor="">Link</label>
            </div>
            {
                socialMediaData.map((media: selectType) =>
                    <div className="form-phoneNumber-box mrg-btm" key = { media.id }>
                        <div className="phoneNumber-box-dropdown-container">
                            <div
                                className="phoneNumber-box-dropdown-header"
                                onClick = {() => openSelectWindow(media)}
                            >
                                {
                                    findActiveMedia(media) !== "Facebook" &&
                                    findActiveMedia(media) !== "Instagram" &&
                                    findActiveMedia(media) !== "LinkedIn" &&
                                    findActiveMedia(media) !== "X" &&
                                    findActiveMedia(media) !== "YouTube" &&
                                    findActiveMedia(media) !== "TikTok" &&
                                    findActiveMedia(media) !== "Messenger" &&
                                    findActiveMedia(media) !== "Pinterest"
                                        ?
                                        <input
                                            type = "text"
                                            className = "other-social-media-input"
                                            value = { findActiveMedia(media) }
                                            onChange = {e => changeOtherMedia(e.target.value, media)}
                                        />
                                        :
                                        findActiveMedia(media)
                                }
                                <ArrowDropDownIcon className="phoneNumber-box-dropdown-header-arrow" />
                            </div>
                            {
                                media.isOpen && (
                                    <ul className="phoneNumber-box-dropdown-list">
                                        {
                                            media.category.map((ctg: radioType) =>
                                                <li
                                                    className = "phoneNumber-box-dropdown-li"
                                                    onClick = {() => onOptionClicked(media, ctg)}
                                                >
                                                    { ctg.title }
                                                </li>
                                            )
                                        }
                                    </ul>
                                )
                            }
                        </div>
                        <input
                            className = "phoneNumber-box-phoneNumber-input"
                            placeholder = "https://"
                            type = "tel"
                            value = { media.text }
                            onChange = {(e) => changeMediaData(e.target.value, media)}
                        />
                        <div className = "phoneNumber-box-delete">
                            {
                                media.id === 1 ?
                                    <div className = "phoneNumber-box-add"
                                         onClick = { addSocialMedia }
                                    >
                                        <AddIcon className="box-addPhone-icon"/>
                                    </div>
                                    :
                                    <DeleteIcon
                                        className = "box-deletePhone-icon"
                                        onClick = {() => deleteSocialMedia(media.id)}
                                    />
                            }
                        </div>
                    </div>
                )}
        </div>
    )
}

export default SocialMedia